// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-catalog-__slug-indexstyleGrid-container-btsor{margin:0 auto;max-width:1536px;padding:0 24px;width:100%}.pages-catalog-__slug-indexstyleGrid-grid-bxoqa{display:grid;grid-gap:24px;grid-template-columns:repeat(12,1fr)}.pages-catalog-__slug-indexstyleGrid-col6-bgerw{grid-column:span 6}.pages-catalog-__slug-indexstyleGrid-col3-bxbzx{grid-column:span 3}.pages-catalog-__slug-indexstyleGrid-col4-brpnb{grid-column:span 4}.pages-catalog-__slug-indexstyleGrid-col9-bkign{grid-column:span 9}.pages-catalog-__slug-indexstyleGrid-col12-bcchl{grid-column:span 12}.pages-catalog-__slug-indexstyleGrid-alignItemsStart-wkmue{align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "pages-catalog-__slug-indexstyleGrid-container-btsor",
	"grid": "pages-catalog-__slug-indexstyleGrid-grid-bxoqa",
	"col6": "pages-catalog-__slug-indexstyleGrid-col6-bgerw",
	"col3": "pages-catalog-__slug-indexstyleGrid-col3-bxbzx",
	"col4": "pages-catalog-__slug-indexstyleGrid-col4-brpnb",
	"col9": "pages-catalog-__slug-indexstyleGrid-col9-bkign",
	"col12": "pages-catalog-__slug-indexstyleGrid-col12-bcchl",
	"alignItemsStart": "pages-catalog-__slug-indexstyleGrid-alignItemsStart-wkmue"
};
module.exports = ___CSS_LOADER_EXPORT___;
